import React, { useState } from "react";
import Layout from "antd/lib/layout";
import classNames from "classnames";
import CollapseIcon from "@ant-design/icons/PauseOutlined";
import ExpandIcon from "@ant-design/icons/ArrowRightOutlined";
import Styles from "./MainLayout.scss";
import AppHeader from "../../containers/AppHeader/Header";
import { Alert } from "antd";

const { Sider, Header: AntHeader, Content: AntContent } = Layout;

type MainLayoutProps = {
    Header?: React.ReactNode;
    Content?: React.ReactNode;
    sidebarCollapsed?: boolean;
    hideSidebar?: boolean;
    hideToggle?: boolean;
    dummySidebar?: boolean;
    children?: React.ReactNode;
};

const MainLayout: React.FC<MainLayoutProps> = ({
    Header = <AppHeader />,
    Content,
    hideSidebar,
    dummySidebar,
    hideToggle,
    sidebarCollapsed: defaultCollapsed,
    children,
}) => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(
        defaultCollapsed !== undefined ? defaultCollapsed : localStorage.getItem("SIDEBAR_STATE") === "collapsed",
    );
    const handleToggleCollapseSidebar = () => {
        setSidebarCollapsed((state) => {
            localStorage.setItem("SIDEBAR_STATE", !state ? "collapsed" : "expanded");
            return !state;
        });
    };

    return (
        <Layout className={Styles.Container}>
            <AntHeader className={Styles.HeaderContainer}>{Header}</AntHeader>
            <Layout className="site-layout">
                <AntContent className={Styles.ContentContainer}>{children || Content}</AntContent>
            </Layout>
        </Layout>
    );
};

export default MainLayout;
